



















































































































import { Component, Vue } from "vue-property-decorator";
import { storeLaundrySupervisi } from "@/store/modules/LaundrySupervisiStore";
import LaundrySupervisiSvc from "@/services/LaundrySupervisiService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import moment from "moment";
import LaundrySupervisiForm from "./LaundrySupervisiForm.vue";
import LaundrySupervisiDetail from "./LaundrySupervisiDetail.vue";

@Component({
  components: { LaundrySupervisiForm, LaundrySupervisiDetail }
})
export default class LaundrySupervisiList extends Vue {
  storeModule = storeLaundrySupervisi;
  showDetail = false;
  editData: any = null;
  isReadonly = false;

  filterTanggalDari = "";
  filterTanggalSampai = "";
  filterStatus = "";

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "Menunggu Acknowledge", value: "submitted" },
    { text: "Acknowledged", value: "acknowledged" },
    { text: "Closed", value: "closed" },
  ];

  headers = [
    { text: "No. Formulir", value: "nomor_formulir", width: "150px" },
    { text: "Tanggal", value: "tanggal_supervisi", width: "110px" },
    { text: "Supervisor", value: "supervisor_nama" },
    { text: "Temuan Utama", value: "temuan_utama" },
    { text: "Status", value: "status", width: "130px" },
    { text: "Aksi", value: "actions", sortable: false, width: "100px" },
  ];

  mounted() {
    this.loadData();
  }

  async loadData() {
    const params: any = {};
    if (this.filterTanggalDari) params.tanggal_dari = this.filterTanggalDari;
    if (this.filterTanggalSampai) params.tanggal_sampai = this.filterTanggalSampai;
    if (this.filterStatus) params.status = this.filterStatus;
    await this.storeModule.loadSessions(params);
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }

  tambahBaru() {
    this.editData = null;
    this.isReadonly = false;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.isReadonly = item.is_locked;
    this.showDetail = true;
  }

  bisaHapus(item: any): boolean {
    if (!item.is_locked) return true;
    const slots = [
      { ditandatangani: item.signed_supervisor_at, penandaTanganId: item.supervisor_id },
      { ditandatangani: item.signed_ka_instalasi_at, penandaTanganId: item.signed_ka_instalasi_id }
    ];
    if (!slots.some(slot => !!slot.ditandatangani)) return false;
    return !alasanTtdMengunciHapus(item.creator_user_id || item.supervisor_id, slots, userModule.user?.id);
  }

  async hapus(item: any) {
    if (!this.bisaHapus(item)) return;
    if (!confirm("Hapus data supervisi ini?")) return;
    try {
      const resp = await LaundrySupervisiSvc.destroy(item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus data");
        this.loadData();
      }
    } catch {
      // handled by ErrorAlert
    }
  }

  printPdf(id: number) {
    LaundrySupervisiSvc.printPdf(id);
  }

  onBack() {
    this.showDetail = false;
    this.editData = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }
}
